module.exports = __webpack_public_path__ + "static/media/GC_lettering_white.52155309.png";